import { z } from 'zod';
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
/**
 * Query params for every list endpoint. Values arrive as strings from the URL,
 * so they are coerced here rather than in each controller.
 */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    sortBy: z.string().trim().min(1).max(64).optional(),
    sortDir: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().trim().max(200).optional(),
});
export const paginationMetaSchema = z.object({
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
});
/** Envelope for every paginated response. */
export const paginated = (item) => z.object({ data: z.array(item), meta: paginationMetaSchema });
export const buildPaginationMeta = (page, pageSize, total) => ({
    page,
    pageSize,
    total,
    totalPages: pageSize > 0 ? Math.ceil(total / pageSize) : 0,
});
//# sourceMappingURL=pagination.js.map